var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('prospect-lists-table',{ref:"prospectlist-table",attrs:{"organization_id":_vm.organization_id,"organization_name":_vm.organization_name,"coach_name":_vm.coach_name,"share":_vm.isShareInterface()}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }